import type { GPMetrics } from "../types"

export interface CounterSnapshot {
  evaluations: number
  invalidEvaluations: number
  repaired: number
  repairFailures: number
  fitnessErrors: number
  nonFiniteFitness: number
  mutations: number
  crossovers: number
  selections: number
  immigrants: number
}

export interface ConfigSnapshot {
  popSize: number
  generations: number
  cxProb: number
  mutProb: number
  crossoverChildren: number
  immigration: number
  tournament: number
  stall: number
  targetFitness: number
  maxWallMs: number
  maxEvaluations: number
  elitesPerGen: number
}

export function buildRunMetrics(
  counters: CounterSnapshot,
  cfg: ConfigSnapshot,
): GPMetrics {
  const {
    popSize,
    generations,
    cxProb,
    mutProb,
    crossoverChildren,
    immigration,
    tournament,
    stall,
    targetFitness,
    maxWallMs,
    maxEvaluations,
    elitesPerGen,
  } = cfg
  return {
    evaluations: counters.evaluations,
    invalidEvaluations: counters.invalidEvaluations,
    repaired: counters.repaired,
    repairFailures: counters.repairFailures,
    fitnessErrors: counters.fitnessErrors,
    nonFiniteFitness: counters.nonFiniteFitness,
    mutations: counters.mutations,
    crossovers: counters.crossovers,
    selections: counters.selections,
    immigrants: counters.immigrants,
    elitesPerGen,
    config: {
      popSize,
      generations,
      cxProb,
      mutProb,
      crossoverChildren,
      immigration,
      tournament,
      stall,
      targetFitness,
      maxWallMs,
      maxEvaluations,
    },
  }
}

